module.exports = require('./helpers/bundle-url').getBundleURL('451m5') + "logo-dark.ba5147f0.svg";